import React, { useState } from 'react';
import { Card, Button } from 'react-daisyui';
import Sidebar from './components/Sidebar';
import TopNavbar from './components/TopNavbar';
import TransactionHistoryChart from './TransactionHistoryChart';
import LatestBlocks from './LatestBlocks';
import LatestTransactions from './LatestTransactions';
import Footer from './components/Footer';


const BerachainInfo = () => {
  const [explanation, setExplanation] = useState('default');

  const explanations = {
    default: "Berachain is a high-performance, Layer 1 blockchain using Proof-of-Liquidity (PoL) consensus. PoL enhances Proof-of-Stake by rewarding liquidity providers. It uses $BERA (gas token) and $BGT (governance token) to ensure stability, security, and growth.",
    bear: "Alright, bear friend, listen up! ?? Berachain is like a big, cozy forest where bears (like you) run things. Instead of gathering honey, you gather liquidity, which keeps the forest safe and strong. You use two special berries: the $BERA berry for everyday bear tasks (like gas) and the $BGT berry to decide who gets the best spots in the forest (governance). The more berries you collect and share, the healthier and more powerful the forest grows. So, keep trading, collecting, and protecting your bear cave�this forest runs on your bear-sized contributions! ??",
    football: "Okay, imagine Berachain is like a big playground. You've got two special toys: $BERA is your swing, and $BGT is your shiny crown. To play on the swing, you need $BERA. But with the crown, you get to decide who gets the best spot on the playground! When you share your toys (liquidity) with others, the playground stays fun and safe for everyone. The more you share, the better it gets! So, keep playing, sharing, and swinging�Berachain is the best playground ever!"
  };

  const buttonText = {
    default: "Explain in Bear terms",
    bear: "Explain it in football terms",
    football: "What is Berachain"
  };

  const nextExplanation = {
    default: "bear",
    bear: "football",
    football: "default"
  };

  const handleExplanationChange = () => {
    setExplanation(nextExplanation[explanation]);
  };

  return (
    <Card className="shadow-[0px_20px_207px_10px_rgba(38,_126,_218,_0.93)] h-full">
      <Card.Body className="flex flex-col justify-between">
        <div>
          <Card.Title tag="h2" className="text-center mb-2">What is Berachain</Card.Title>
          <div className="flex gap-2 mb-4">
            <div className="bg-red-500 h-1 w-1/4 rounded"></div>
            <div className="bg-cyan-400 h-1 w-1/4 rounded"></div>
            <div className="bg-yellow-500 h-1 w-2/4 rounded"></div>
          </div>
          <p className="text-sm">{explanations[explanation]}</p>
        </div>
        <Button 
          onClick={handleExplanationChange} 
          className="mt-4 hover:bg-cyan-400 hover:text-black transition-colors duration-300"
        >
          {buttonText[explanation]}
        </Button>
      </Card.Body>
    </Card>
  );
};

const BlockchainExplorer = () => {
  return (
    <div className="min-h-screen bg-black text-white flex">
      {/* Warning message for mobile users */}
      <div className="fixed top-0 left-0 w-full bg-yellow-400 text-black p-4 text-center z-50 md:hidden">
        This website is not optimized for mobile devices.
      </div>

      {/* Main content, hidden on small screens */}
      <div className="hidden md:flex flex-1">
        <Sidebar />
        <div className="flex-1 flex flex-col">
          <div className="flex-1 p-4 pl-20 flex flex-col">
            <TopNavbar />
            <div className="mb-4">
              <LatestBlocks />
            </div>
            <div className="grid grid-cols-3 gap-4 mb-4 flex-grow">
              <BerachainInfo />
              <LatestTransactions />
              <TransactionHistoryChart />
            </div>
            {/* Place Footer here */}
            <Footer />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlockchainExplorer;